import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { getRemainingTimeUntilMsTimestamp } from "../Utils/TimestamUtils";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Circles } from "../../../theme";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import environmentVariables from "../../../config/environmentVariables";

const CollectionBanner2 = `CollectionBanner2.jpg`
const Root = styled.div`
  width: 100%;
`;
const Container = styled.div``;

const Image = styled.img`
  width: 100%;
  border-radius: 15px;
`;

const CountdownWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  top: 20px;
  right: -510px;

  position: absolute;
  width: 100%;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
  }
`;
const CountBoxWrapper = styled.div`
  /* background: rgba(255, 255, 255, 0.2); */
  border-radius: 8px;
  padding: 13px 0px;
  /* margin: 0 5px; */
  line-height: 10px;
  @media (max-width: 768px) {
    /* padding: 4px 6px; */
  }
`;

const CountdownText = styled.div`
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
`;
const CountText = styled.text`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
`;

const CountBox = styled.div`
  text-align: center;
  padding: 2px 0;
  font-weight: 700;
  font-size: 22px;
  line-height: 24px;
`;

const BannerTextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  width: 100%;
  position: absolute;
  bottom: 40px;
  padding: 0 60px;
  justify-content: space-between;
  @media (max-width: 768px) {
    left: 40px;
    padding: 0;
    flex-direction: column;
    align-items: flex-start;
  }
  @media (max-width: 1024px) {
    left: 40px;
    padding: 0;
    flex-direction: column;
    align-items: flex-start;
  }
  /* @media(max-width:1440px){
    bottom: 80px;
  } */
`;
const BannerText = styled.text`
  font-style: normal;
  font-weight: 700;
  font-size: 50px;
  line-height: 54px;
  text-transform: capitalize;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: "Lato";
  position: relative;
  @media (max-width: 768px) {
    font-size: 28px;
    line-height: 33px;
    margin-top: 20px;
  }
  @media (max-width: 1024px) {
    font-size: 28px;
    line-height: 33px;
    margin-top: 20px;
  }
`;

const NftValueViewContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 90%;
  width: 100%;
  background: linear-gradient(360deg, #000000 41.25%, rgba(0, 0, 0, 0) 100%);
  @media (max-width: 768px) {
    top: 82%;
    padding: 0 20px;
  }
  @media (max-width: 1024px) {
    top: 82%;
    padding: 0 20px;
  }
`;
const ValueWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;
const ValueText = styled.text`
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-transform: capitalize;
  color: #ffffff;
  font-family: system-ui;
  @media (max-width: 640px) {
    font-size: 15px;
  }
`;
const Value = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  text-transform: capitalize;
  margin: 5px 0;
  font-family: system-ui;
  @media (max-width: 640px) {
    font-size: 15px;
  }
`;
const LineWrapper = styled.div``;
const Line = styled.div`
  opacity: 0.2;
  border: 1px solid #ffffff;
  height: 58px;
  width: 0;
  margin: 0 30px;
  @media (max-width: 640px) {
    margin: 0 10px;
  }
`;

const CountdownTextWrapper = styled.div`
  @media (max-width: 768px) {
    margin-bottom: 5px;
  }
  @media (max-width: 1024px) {
    margin-bottom: 5px;
  }
`;
const CountdownValueWrapper = styled.div`
  display: flex;
  padding: 0 20px;
  justify-content: center;
  border-radius: 25px;
  background-color: #1e1e1e9e;
  color: #dddddd;
  border: 1px solid #1c1c1c;
  @media (max-width: 640px) {
    display: flex;
    padding: 5px 15px;
  }
`;
const CounterIcon = styled.img``;
const CounterIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: Center;
  text-align: center;
  padding: 0 10px;
  /* position: absolute;
left:42%; */
`;

const defaultRemainingTime = {
  seconds: "00",
  minutes: "00",
  hours: "00",
  days: "00",
};

const NftCategorymain = styled.div`
  position: absolute;
  top: -30px;
  left: 0;
  display: flex;
`

const NftCategory = styled.div`
  font-size: 12px;
  font-weight: 800;
  color: #490d81;
  text-transform: uppercase;
  background-color: #d3b1f3;
  padding: 0px 10px;
  border-radius: 50px;
  /* position: absolute; */
  /* top: -24px; */
  /* left: 0; */
  line-height: 24px;
  ${(p) =>
    p.rare &&
    `
      background-color: #a5e3b8;
      color: #2b713e;
      `};
  ${(p) =>
    p.common &&
    `
        background-color: #dddddd;
        color: #535353;
      `};
`;
const NftCategory1 = styled.div`
  font-size: 12px;
  font-weight: 800;
  color: #2a831b;
  text-transform: uppercase;
  background-color: #cce7d5;
  padding: 0px 20px;
  border-radius: 50px;
  /* position: absolute;
  top: -25px;
  left: 90px; */
  line-height: 24px;
  margin-left: 10px;
`;
const BannersmallText = styled.text`
  color: #cbcbcb;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  @media (max-width: 768px) {
    align-items: flex-start;
  }
  @media (max-width: 1024px) {
    align-items: flex-start;
  }
`;
const BannersmallTextHead = styled.text`
  color: #ababab;
  font-size: 14px;
  padding-right: 5px;
`;
const BannersmallTextPrice = styled.text`
  color: #10afd1;
  font-size: 33px;
  padding-left: 5px;
  display: flex;
  align-items: center;
`;

const BannerSubText = styled.text`
  background-color: #fff;
  border-radius: 50px;
  padding: 15px 60px;
  color: #000;
  border: 1px solid #26738373;
  font-size: 16px;
  font-family: "Lato";
  font-weight: 600;
  margin-top: 10px;
  transition: 1s;
  cursor: pointer;
  &:hover {
    background-color: #17293052;
    color: #fff;
  }
`;

const Imagewrapper = styled.div`
  background: url(${CollectionBanner2});
  /* background-size: 100%; */
  background-position: center;
  width: 100%;
  z-index: 999;
  background-repeat: no-repeat;
  margin: 20px 0;
  border-radius: 10px;
  height: 400px;
  transition: 1s;
  position: relative;
  transition: 1s;
  filter: none;
  &:hover {
    /* background-size: 110%; */
    filter: grayscale(0.5);
  }
  &:hover ${BannerSubText} {
    /* background-color: #10afd1; */
    background-color: rgba(23, 41, 48, 0.32);
    color: rgb(255, 255, 255);
  }
  @media (max-width: 1200px) {
    height: 340px;
  }
  @media (max-width: 1024px) {
    background-size: cover;
  }
`;

const BidMain = styled.text`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  @media (max-width: 768px) {
    align-items: flex-start;
    padding-top: 20px;
  }
  @media (max-width: 1024px) {
    align-items: flex-start;
    padding-top: 20px;
  }
`;
const BannerNftMarket = ({ countdownTimestampMs }) => {
  const [remainingTime, setRemainingTime] = useState(defaultRemainingTime);
  const [allAuctionData, setAllAuctionData] = useState();
  const navigation = useNavigate();

  const AuctionDataHandle = () => {
    axios
      .get(
        `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/getauctionednft`
      )
      .then((res) => {
        // console.log("AuctionDataHandleqqqqqqqqqqqq", res.data);
        setAllAuctionData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    AuctionDataHandle();
    const intervalId = setInterval(() => {
      updateRemainingTime(countdownTimestampMs);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [countdownTimestampMs]);

  function updateRemainingTime(countdown) {
    setRemainingTime(getRemainingTimeUntilMsTimestamp(countdown));
  }

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // autoplay: true,
    autoplaySpeed: 3000,
    infinite: true,
  };

  return (
    <Root>
      <Container>
        <Slider {...settings}>
          {allAuctionData?.map((item, index) => {
            return (
              <div key={index}>
                <Imagewrapper>
                  <BannerTextWrapper>
                    <div>
                      <BannerText>
                        {item?.name}
                        <NftCategorymain>
                          <NftCategory>{item?.category}</NftCategory>
                          <NftCategory1># {item?.hash}</NftCategory1>
                        </NftCategorymain>
                      </BannerText>
                    </div>
                    <BidMain>
                      <BannersmallText>
                        <BannersmallTextHead>Current Bid</BannersmallTextHead>
                        <BannersmallTextPrice>
                          <Circles></Circles>
                          {item?.price} {item?.currency}
                        </BannersmallTextPrice>
                      </BannersmallText>
                      <BannerSubText
                        onClick={() => {
                          navigation(
                            `/nftdetails/${item?.contractAddress}/${item?.tokenId}`
                          );
                        }}
                      >
                        Place a Bid
                      </BannerSubText>
                    </BidMain>
                  </BannerTextWrapper>

                  {/* <CountdownWrapper>
                   <CountdownValueWrapper>
                   <CounterIconWrapper>
                    <CounterIcon src={CounterVectorIcon}/>
                   </CounterIconWrapper>
                     <CountBoxWrapper>
                       <CountBox> {remainingTime.days} : </CountBox>
                     
                     </CountBoxWrapper>
                     <CountBoxWrapper>
                       <CountBox> {remainingTime.hours} : </CountBox>
                     
                     </CountBoxWrapper>
                     <CountBoxWrapper>
                       <CountBox> {remainingTime.minutes} : </CountBox>
                       
                     </CountBoxWrapper>
                     <CountBoxWrapper>
                       <CountBox> {remainingTime.seconds} </CountBox>
                      
                     </CountBoxWrapper>
                   </CountdownValueWrapper>
                 </CountdownWrapper> */}
                </Imagewrapper>
              </div>
            );
          })}
        </Slider>
      </Container>
    </Root>
  );
};

export default BannerNftMarket;
